(() => {
  document.addEventListener('submit', event => {
    if (event.target.id !== 'cart-form') return;
    const blocked = document.querySelector('[data-hw-card-minimum-blocked="true"]');
    if (!blocked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    document.querySelector('.hw-card-minimum-notice')?.scrollIntoView({behavior:'smooth',block:'center'});
  }, true);
  const root = document.getElementById('ec-instantsite');
  if (!root) return;
  root.querySelectorAll('.shopify-section').forEach(section => {
    // Native cart components refresh through their Shopify section wrapper.
    if (!section.querySelector('cart-items-component')) section.replaceWith(...section.childNodes);
  });
  const sourcePictures = [...root.querySelectorAll('picture')].filter(picture => !picture.classList.contains('ins-picture--thumb') && !picture.classList.contains('blur-[5px]'));
  function finishPicture(picture) {
    const image = picture.querySelector('img');
    if (!image?.naturalWidth) return;
    if (picture.classList.contains('bg-cover')) picture.style.backgroundImage = `url("${image.currentSrc || image.src}")`;
    const placeholder = picture.nextElementSibling;
    if (placeholder?.tagName === 'PICTURE' && (placeholder.classList.contains('ins-picture--thumb') || placeholder.classList.contains('blur-[5px]'))) placeholder.hidden = true;
  }
  sourcePictures.forEach(picture => {picture.querySelector('img')?.addEventListener('load', () => finishPicture(picture));finishPicture(picture);});
  const backgrounds = [...root.querySelectorAll('.ins-tile__background .ins-tile__image')];
  function layout() {
    const width = document.documentElement.clientWidth;
    for (const breakpoint of [300,400,500,600,700,900,1100]) root.classList.toggle('ins-tiles--' + breakpoint, width >= breakpoint);
    root.style.setProperty('--vh', String(window.innerHeight));
    root.style.setProperty('--scrollbarWidth', (window.innerWidth-width)+'px');
    const header = root.querySelector('[tile-type="HEADER"]');
    const firstCover = header?.nextElementSibling;
    if (firstCover?.classList.contains('ins-tile--cover')) firstCover.style.setProperty('--announcement-bar-height', String(header.previousElementSibling?.getBoundingClientRect().height || 0));
    backgrounds.forEach(el => {
      const picture = el.querySelector('picture');
      const image = picture?.querySelector('img');
      if (!image?.naturalWidth) return;
      picture.style.backgroundImage = `url("${image.currentSrc || image.src}")`;
      const fixed = el.parentElement.classList.contains('ins-tile__background--fixed');
      const box = el.parentElement.getBoundingClientRect();
      const height = (fixed ? window.innerHeight : box.height) + 1;
      const scale = Math.max((box.width + 1)/image.naturalWidth, height/image.naturalHeight);
      const x = image.naturalWidth * scale, y = image.naturalHeight * scale;
      el.style.setProperty('--background-size-x', x + 'px');
      el.style.setProperty('--background-size-y', y + 'px');
      el.style.setProperty('--background-position-x', (box.width - x)/2 + 'px');
      el.style.setProperty('--background-position-y', ((fixed ? window.innerHeight : box.height) - y)/2 + 'px');
      const fallback = picture.nextElementSibling;
      if (fallback?.tagName === 'PICTURE') fallback.style.display = 'none';
    });
    root.querySelectorAll('.ins-tile__slider').forEach(slider => {
      const image = slider.querySelector('.ins-tile__product-image');
      const controls = slider.parentElement.querySelector('.ins-tile__controls');
      if (controls && image) controls.style.height = image.getBoundingClientRect().height + 'px';
    });
  }
  root.querySelectorAll('picture img').forEach(image => image.addEventListener('load', layout));
  window.addEventListener('resize', layout);
  layout();
  root.querySelectorAll('.hw-menu-native').forEach(menu => menu.addEventListener('toggle', () => {document.body.style.overflow = menu.open ? 'hidden' : '';layout();}));
  root.querySelectorAll('.ins-accordion__item-header').forEach(header => {
    const toggle = () => {
      const item = header.closest('.ins-accordion__item');
      const expanded = header.getAttribute('aria-expanded') !== 'true';
      header.setAttribute('aria-expanded', String(expanded));
      item.classList.toggle('ins-accordion__item--collapse', !expanded);
      item.classList.toggle('ins-accordion__item--expand', expanded);
      const content = item.querySelector('.ins-accordion__item-content');
      if (content) {
        if (!item.closest('.hw-pet-faq') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          content.hidden = !expanded;
          return;
        }
        const startHeight = content.hidden ? 0 : content.getBoundingClientRect().height;
        const startOpacity = content.hidden ? 0 : parseFloat(getComputedStyle(content).opacity);
        const startPadding = content.hidden ? 0 : parseFloat(getComputedStyle(content).paddingBottom);
        content.hwFaqAnimation?.cancel();
        content.hidden = false;
        content.inert = !expanded;
        const endHeight = content.scrollHeight;
        const endPadding = parseFloat(getComputedStyle(content).paddingBottom);
        const animation = content.animate([
          {height: startHeight + 'px', opacity: startOpacity, paddingBottom: startPadding + 'px'},
          {height: (expanded ? endHeight : 0) + 'px', opacity: expanded ? 1 : 0, paddingBottom: (expanded ? endPadding : 0) + 'px'}
        ], {duration: 300, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'both'});
        content.hwFaqAnimation = animation;
        animation.onfinish = () => {
          if (content.hwFaqAnimation !== animation) return;
          content.hidden = header.getAttribute('aria-expanded') !== 'true';
          animation.cancel();
          content.hwFaqAnimation = null;
        };
      }
    };
    header.addEventListener('click', toggle);
    header.addEventListener('keydown', event => {if (event.key === 'Enter' || event.key === ' ') {event.preventDefault();toggle();}});
  });
  root.querySelectorAll('.ins-tile__control-next,.ins-tile__control-prev').forEach(control => {
    const move = () => {
      const section = control.closest('section');
      const slider = section?.querySelector('.ins-tile__slider');
      const track = slider?.querySelector('.ins-tile__body-inner');
      if (!slider || !track) return;
      const next = control.classList.contains('ins-tile__control-next');
      slider.scrollBy({left: (next ? 1 : -1) * slider.clientWidth, behavior:'smooth'});
      track.scrollBy({left: (next ? 1 : -1) * track.clientWidth, behavior:'smooth'});
    };
    control.addEventListener('click', move);
    control.addEventListener('keydown', event => {if(event.key === 'Enter' || event.key === ' ') {event.preventDefault();move();}});
  });
  root.querySelectorAll('[tile-type="IMAGE_GALLERY"]').forEach(gallery => {
    const images=[...gallery.querySelectorAll('img')].filter(image=>!image.parentElement.classList.contains('blur-[5px]'));
    if(!images.length)return;
    const dialog=document.createElement('dialog');dialog.className='hw-product-viewer';dialog.setAttribute('aria-label','Image gallery viewer');
    dialog.innerHTML='<button type="button" class="hw-viewer-close" aria-label="Close image viewer"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><button type="button" class="hw-viewer-prev" aria-label="Previous image">‹</button><figure><img alt=""><figcaption aria-live="polite"></figcaption></figure><button type="button" class="hw-viewer-next" aria-label="Next image">›</button>';
    document.body.append(dialog);
    let current=0,restoreFocus=null;
    const full=dialog.querySelector('img'),caption=dialog.querySelector('figcaption');
    const show=index=>{current=(index+images.length)%images.length;const image=images[current];full.src=image.currentSrc||image.src;full.alt=image.alt;caption.textContent=(current+1)+' / '+images.length;};
    images.forEach((image,index)=>{const open=()=>{restoreFocus=image;show(index);dialog.showModal();document.body.classList.add('hw-viewer-open');};image.tabIndex=0;image.setAttribute('role','button');image.setAttribute('aria-label','Enlarge '+(image.alt||'gallery image'));image.addEventListener('click',open);image.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();open();}});});
    dialog.querySelector('.hw-viewer-close').addEventListener('click',()=>dialog.close());
    dialog.querySelector('.hw-viewer-prev').addEventListener('click',()=>show(current-1));
    dialog.querySelector('.hw-viewer-next').addEventListener('click',()=>show(current+1));
    dialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();show(current-1);}if(event.key==='ArrowRight'){event.preventDefault();show(current+1);}});
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    dialog.addEventListener('close',()=>{document.body.classList.remove('hw-viewer-open');restoreFocus?.focus();});
    let touchX=0;dialog.addEventListener('touchstart',event=>{touchX=event.changedTouches[0].clientX;},{passive:true});dialog.addEventListener('touchend',event=>{const delta=event.changedTouches[0].clientX-touchX;if(Math.abs(delta)>50)show(current+(delta<0?1:-1));},{passive:true});
    if(images.length<2){dialog.querySelector('.hw-viewer-prev').hidden=true;dialog.querySelector('.hw-viewer-next').hidden=true;}
  });
})();

(() => {
 const header=document.querySelector('.hw-site-header');if(!header)return;
 const nav=header.querySelector('.hw-main-navigation'),mobile=header.querySelector('.hw-mobile-toggle'),items=[...header.querySelectorAll('.hw-nav-item')];
 function set(item,open){item.querySelector('.hw-nav-toggle').setAttribute('aria-expanded',String(open));item.querySelector('.hw-nav-panel').hidden=!open;}
 function close(){items.forEach(item=>set(item,false));}
 items.forEach(item=>{const button=item.querySelector('.hw-nav-toggle');button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';close();set(item,open);});item.addEventListener('mouseenter',()=>{if(matchMedia('(min-width:901px) and (hover:hover)').matches){close();set(item,true);}});item.addEventListener('mouseleave',()=>{if(matchMedia('(min-width:901px) and (hover:hover)').matches&&!item.contains(document.activeElement))set(item,false);});item.addEventListener('focusout',event=>{if(!item.contains(event.relatedTarget))set(item,false);});});
 mobile.addEventListener('click',()=>{const open=mobile.getAttribute('aria-expanded')!=='true';mobile.setAttribute('aria-expanded',String(open));mobile.setAttribute('aria-label',open?'Close menu':'Open menu');nav.classList.toggle('is-open',open);if(!open)close();});
 document.addEventListener('click',event=>{if(!header.contains(event.target)){close();nav.classList.remove('is-open');mobile.setAttribute('aria-expanded','false');mobile.setAttribute('aria-label','Open menu');}});
 header.addEventListener('keydown',event=>{if(event.key==='Escape'){const expanded=items.find(item=>item.querySelector('.hw-nav-toggle').getAttribute('aria-expanded')==='true');close();if(expanded)expanded.querySelector('button').focus();else{nav.classList.remove('is-open');mobile.setAttribute('aria-expanded','false');mobile.setAttribute('aria-label','Open menu');mobile.focus();}}});
 nav.querySelectorAll('a[href]').forEach(link=>{const url=new URL(link.getAttribute('href'),location.href);if(url.pathname===location.pathname&&!url.hash)link.setAttribute('aria-current','page');});
})();

/* External web destinations open in a separate tab throughout Hiriwa. */
(()=>{
 const internalHosts=new Set([location.hostname,'hiriwa.co.nz','www.hiriwa.co.nz','hiriwa-digital-art-twpwv7en.myshopify.com']);
 const prepare=link=>{
  const url=new URL(link.href,location.href);
  if(!/^https?:$/.test(url.protocol)||internalHosts.has(url.hostname))return;
  link.target='_blank';
  link.rel=[...new Set([...link.relList,'noopener','noreferrer'])].join(' ');
 };
 const scan=root=>{
  if(root.matches?.('a[href]'))prepare(root);
  root.querySelectorAll?.('a[href]').forEach(prepare);
 };
 scan(document);
 new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(scan))).observe(document.body,{childList:true,subtree:true});
 document.addEventListener('click',event=>{const link=event.target.closest?.('a[href]');if(link)prepare(link)},true);
})();
